import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const DataScreen = lazy(() => import("./DataScreen"));

const DATASCREEN_ROUTES: RouteObject[] = [
  {
    path: "/private/data",
    element: React.createElement(DataScreen),
  },
];

export default DATASCREEN_ROUTES;
